import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const SOURCING_EVENT_SUPPLIER_ASSOCS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator(
	'SOURCING_EVENT_SUPPLIER_ASSOCS'
);
export const SOURCING_EVENT_SUPPLIER_ASSOCS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	SOURCING_EVENT_SUPPLIER_ASSOCS_CRUD_ACTION_CONSTANTS
);
